import React from 'react';
import Img from "../../images/services/et/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Discover The True Potential Of Your Business!</h2>
                        <p>Emerging technologies are changing the way this world functions. IoT, artificial
                            intelligence, data analytics, machine learning, metaverse, BLE, and other solutions enable
                            businesses worldwide to embrace digital change and thrive through emerging technology in
                            business.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;